import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { CustomCbDefFieldsStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppStyles } from '../../../styles/AppTheme';

export class CoFields extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = Helper.getString('fields')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.itemId = this.props.match.params.id
    this.entityAttrName = 'fields'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('cotypes'), to: this.baseRoute() + '/cotypes' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['cotypes', this.itemId], queryParams: { pb: 'fieldDefCoFields' } },
    ]
    this.tableHeadersMap = {
      Order: (current) => { return current.order },
      'Key / Label': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.label}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>{'{{' + current.key + '}}'}</span>
          </div>
        )
      },
      Type: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.iType}</span>
          </div>
        )
      },
      Mandatory: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.mandatory}</span>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      orgId: this.orgId
    }
  }

  onFetchSuccess(results) {
    console.log('CoFields:onFetchSuccess:', results)
    this.fieldDef = results[0].fieldDefCoFields
    this.formDefinition = this.fieldDef
    this.setState({
      items: Helper.sortDictArray(Helper.dictToArray(results[0].fields))
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.itemId], { }),
    })
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.itemId], { }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['cotypes', this.itemId], { }),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    if(current.iType === 'NESTED_OBJECT') {
      actions.push(
        <Link
          to={this.baseRoute() + '/cotypes/' + this.itemId + '/fields/' + current.id + '/nestedfields'}
          key={current.id + '-nestedfields'}>
          <Tooltip title='Nested fields' placement='top-start' key={current.id + 'nestedfields'}>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>dataset</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    return actions
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomCbDefFieldsStyles : StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})